<template>
  <tela-indisponivel titulo="Fluxo de Caixa" />
</template>

<script>
// Arquivo de 0 bytes desde 2019 (2129a795), com rota em src/router/router.js e
// nenhum link em menu nenhum. Ver src/components/Utils/tela-indisponivel.vue.
import TelaIndisponivel from '@/components/Utils/tela-indisponivel.vue';

export default {
  name: 'fluxo_de_caixa',
  components: { TelaIndisponivel },
};
</script>
